'use client';

import { useCallback, useMemo } from 'react';
import classnames from 'classnames';

import { useCookies } from '@personly/libs-providers';

import { useConsents } from '../../providers/consents';

const className = classnames(
  'border',
  'border-background-title-color',
  'py-1.5',
  'px-2',
  'rounded',
  'bg-button-background-color',
  'text-button-text-color',
  'focus:outline-none',
  'active:outline-none',
  'hover:outline-none',
  'disabled:!opacity-60',
  'disabled:!border',
  'opacity-45'
);

const ConsentAcceptRequiredButton = ({ children, cookieTypes }) => {
  const { setConsent } = useCookies();
  const { setSelectedCookieTypes } = useConsents();

  const types = useMemo(
    () =>
      cookieTypes
        .filter(({ flags }) => flags.isRequired)
        .map(({ handle }) => handle),
    [cookieTypes]
  );

  const onClick = useCallback(() => {
    setConsent({ types, createdAt: new Date().getTime() });
    setSelectedCookieTypes(types);
  }, [setConsent, setSelectedCookieTypes, types]);

  return (
    <button className={className} onClick={() => onClick()}>
      {children}
    </button>
  );
};

export default ConsentAcceptRequiredButton;
